import React from 'react';
import { TileProps } from './Types';
import { styled } from '@mui/material/styles';

type StyledTextProps = {
  tileFontStyle?: TileProps['tileFontStyle'];
};

const Tile = ({ text, backgroundColor, tileFontStyle }: TileProps) => {
  return (
    <div
      className="text-black p-4 flex items-center relative z-41"
      style={{
        backgroundColor: backgroundColor || 'rgba(255, 255, 255, 0.9)',
        boxShadow: '0px 8px 10px 0px rgba(0, 0, 0, 0.30)',
      }}
    >
      <StyledText className="relative z-50" tileFontStyle={tileFontStyle}>
        {text}
      </StyledText>
    </div>
  );
};

const StyledText = styled('p', {
  shouldForwardProp: (prop) => prop !== 'tileFontStyle',
})<StyledTextProps>(({ tileFontStyle }) => ({
  color: tileFontStyle?.textColor || '#000',
  fontFamily: tileFontStyle?.fontFamily || '"Source Sans 3"',
  fontSize: tileFontStyle?.fontSize || '22px',
  fontStyle: 'normal',
  fontWeight: tileFontStyle?.fontWeight || 500,
  lineHeight: tileFontStyle?.lineHeight || 'normal',
  letterSpacing: tileFontStyle?.letterSpacing,
  textTransform: 'capitalize',
}));

export default Tile;
